import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

export const useStyles = makeStyles({
  root: {
    padding: '0.9375rem',
  },
  title: {
    margin: '0.625rem 0',
    textAlign: 'center',
    width: '100%',
    textTransform: 'none',
  },
  description: {
    color: colors.light_grey_6,
    textAlign: 'center',
    width: '100%',
  },
  ctaContainer: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    marginTop: '3.125rem',
    '& a': {
      borderBottom: `0.0625rem solid ${colors.light_grey_2}`,
      margin: '1.25rem',
    },
    width: '100%',
  },
});
